import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/**
 * Returns whether the user has requested reduced motion via the OS-level
 * setting. SSR-safe: defaults to `false` until the effect resolves on the
 * client. CSS transitions/animations are gated globally in `tokens.css`;
 * use this hook only when a JS-driven animation needs to skip a setTimeout
 * or RAF loop.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }
    const mql = window.matchMedia(QUERY)
    setReduced(mql.matches)

    const handler = (event: MediaQueryListEvent): void => {
      setReduced(event.matches)
    }

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler)
      return () => mql.removeEventListener('change', handler)
    }
    // Safari < 14 fallback
    mql.addListener(handler)
    return () => mql.removeListener(handler)
  }, [])

  return reduced
}
